import { Controller } from "@hotwired/stimulus"

// This controller is used to handle message editor in inbox
export default class extends Controller {
  static get targets() {
    return ["bodyInput", "submitButton", "form", "trixEditor"]
  }

  bodyUpdate() {
    this.submitButtonTarget.disabled = this.bodyInputTarget.value.length === 0
  }

  draft() {
    if (!this.formTarget) return

    const formData = new FormData(this.formTarget)
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 10000) // 10 second timeout

    fetch("/messages/drafts", {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "application/json"
      },
      body: formData,
      signal: controller.signal
    })
      .then(async response => {
        clearTimeout(timeoutId)
        let errorMessage = i18n.t("js.back.messages.drafts.errors.draft_failed")

        if (!response.ok) {
          errorMessage = this.getErrorMessage(response.status)
          throw new Error(errorMessage)
        }

        return response.json()
      })
      .then(response => {
        // For message in text format we need to ensure we use the stripped version
        if (response.message.message_format == "text") {
          this.trixEditorTarget.editor.loadHTML(response.message.body)
        }
      })
      .catch(error => {
        clearTimeout(timeoutId)

        if (error.name === 'AbortError') {
          App.displayFlash("danger", i18n.t("js.back.messages.drafts.errors.timeout"))
        } else if (error.name === 'SyntaxError') {
          App.displayFlash("danger", i18n.t("js.back.messages.drafts.errors.draft_failed"))
        } else {
          App.displayFlash("danger", error.message || i18n.t("js.back.messages.drafts.errors.unexpected_error"))
        }
      })
  }

  getErrorMessage(status) {
    switch (status) {
      case 422:
        return i18n.t("js.back.messages.drafts.errors.validation_error")
      case 401:
        return i18n.t("js.back.messages.drafts.errors.session_expired")
      case 403:
        return i18n.t("js.back.messages.drafts.errors.permission_denied")
      case 500:
        return i18n.t("js.back.messages.drafts.errors.server_error")
      default:
        return i18n.t("js.back.messages.drafts.errors.draft_failed")
    }
  }
}
